import BasicRecord from "./BasicRecord";

type TreeNode = {
    name: string;
    path: string;
    distanceToFarestLeaf: number;
    children: TreeNode[];
};

type Level = {
    [key: string]: Level;
} & {
    result: TreeNode[];
};

function generateTreeFromPaths(paths: string[]) {
    const result: TreeNode[] = [];
    const level = { result } as Level;

    paths.forEach(path => {
        const pathArray = path.split("/");

        pathArray.reduce((acc, name, index) => {
            const distanceToLeaf = pathArray.length - index - 1;

            if (acc[name]) {
                acc.result.map(node => {
                    if (node.name === name && distanceToLeaf > node.distanceToFarestLeaf) {
                        node.distanceToFarestLeaf = distanceToLeaf;
                    }

                    return node;
                });
            } else {
                acc[name] = {
                    result: [] as TreeNode[]
                } as Level;
                acc.result.push({
                    name,
                    path: pathArray.slice(0, index + 1).join("/"),
                    distanceToFarestLeaf: distanceToLeaf,
                    children: acc[name].result
                });
            }

            return acc[name];
        }, level);
    });

    return result;
}

function generateTreeFromArray({
    array,
    identifier,
    childrenKey,
    parentKey
}: {
    array: BasicRecord[];
    identifier: string;
    childrenKey: string;
    parentKey: string;
}) {
    const tree = [];
    const indexMap: BasicRecord<number> = {};

    for (let i = 0; i < array.length; i++) {
        indexMap[array[i][identifier]] = i;
        (array[i][childrenKey] as unknown as BasicRecord[]) = [];
    }

    for (let i = 0; i < array.length; i++) {
        const parentId = array[i][parentKey];
        const parent = parentId && array[indexMap[parentId]];

        if (parent) {
            (parent[childrenKey] as unknown as BasicRecord[]).push(array[i]);
        } else {
            delete array[i][parentKey];
            tree.push(array[i]);
        }
    }

    return tree;
}

function flatTree({
    tree,
    identifier,
    childrenKey,
    path
}: {
    tree: BasicRecord[];
    identifier: string;
    childrenKey: string;
    path?: string[];
}) {
    let result: BasicRecord[] = [];

    tree.forEach(item => {
        const subSections = [...item[childrenKey]];

        if (path) {
            (item["path"] as unknown as string[]) = path;
        }

        delete item[childrenKey];

        result.push(item);

        result = result.concat(
            flatTree({
                tree: subSections as unknown as BasicRecord[],
                identifier,
                childrenKey,
                path: [...(path || []), item[identifier]]
            })
        );
    });

    return result;
}

export {
    TreeNode,
    generateTreeFromPaths,
    generateTreeFromArray,
    flatTree
};
